import { success, error as notificationError } from 'react-notification-system-redux';
import store from '@src/store';
export const SAVE_PREFERENCES_START = 'SAVE_PREFERENCES_START';
export const SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';
export const SAVE_PREFERENCES_ERROR = 'SAVE_PREFERENCES_ERROR';
export const SAVE_PREFERENCES_LOADING = 'SAVE_PREFERENCES_LOADING';

const savePreferencesSuccess = {
  title: 'Preferences Update Successful',
  message: 'You have successfully updated your account preferences.',
  position: 'tc',
  autoDismiss: 0,
};

const savePreferencesError = {
  title: 'Preferences Update Error',
  message: 'There was an error updating your account preferences.',
  position: 'tc',
  autoDismiss: 0,
};
export type Actions = {
  SAVE_PREFERENCES_START: {
    type: typeof SAVE_PREFERENCES_START;
    payload: boolean;
  };
  SAVE_PREFERENCES_LOADING: {
    type: typeof SAVE_PREFERENCES_LOADING;
    payload: boolean;
  };
  SAVE_PREFERENCES_SUCCESS: {
    type: typeof SAVE_PREFERENCES_SUCCESS;
    payload: any;
  };
  SAVE_PREFERENCES_ERROR: { type: typeof SAVE_PREFERENCES_ERROR; payload: any };
};
// Action Creators
export const actionCreators = {
  savePreferencesStart: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_START] => ({
    type: SAVE_PREFERENCES_START,
    payload,
  }),
  savePreferencesError: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_ERROR] => {
    store.dispatch(notificationError(savePreferencesError));
     return ({ type: SAVE_PREFERENCES_ERROR, payload: payload});
   },
  savePreferencesSuccess: (
    payload: any,
  ): Actions[typeof SAVE_PREFERENCES_SUCCESS] => ({
    type: SAVE_PREFERENCES_SUCCESS,
    payload,
  }),
  savePreferencesLoading: (
    payload: boolean,
  ): Actions[typeof SAVE_PREFERENCES_LOADING] => ({
    type: SAVE_PREFERENCES_LOADING,
    payload,
  }),
  savePreferencesSuccessNotification: (): void => {
    store.dispatch(success(savePreferencesSuccess));
  },
  savePreferencesErrorNotification: (): void => {
    store.dispatch(notificationError(savePreferencesError));
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/preferences/actions.ts